import { render, staticRenderFns } from "./HijackComponent.vue?vue&type=template&id=2e84ec3c"
import script from "./HijackComponent.vue?vue&type=script&lang=js"
export * from "./HijackComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports